const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAudible(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "512px",
    height: "319px",
    viewBox: "0 0 511 319",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "surface1"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.254902%,60.000002%,10.980392%)",
      fillOpacity: 1
    },
    d: "M 256.300781 273.015625 L 512.265625 113.332031 L 512.265625 156.636719 L 256.300781 316.996094 L 0 156.636719 L 0 113.332031 Z M 256.300781 273.015625 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.254902%,60.000002%,10.980392%)",
      fillOpacity: 1
    },
    d: "M 256.300781 72.738281 C 313.78125 72.738281 364.839844 102.847656 394.597656 146.488281 L 357.0625 170.507812 C 300.597656 95.066406 196.789062 81.53125 124.769531 141.414062 C 122.402344 143.105469 121.050781 144.457031 118.683594 146.828125 C 147.761719 101.832031 198.480469 72.738281 256.300781 72.738281 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.254902%,60.000002%,10.980392%)",
      fillOpacity: 1
    },
    d: "M 256.300781 146.828125 C 287.746094 146.828125 315.472656 162.050781 331.027344 186.746094 L 295.1875 209.074219 C 278.617188 185.054688 253.933594 170.847656 226.207031 170.847656 C 209.640625 170.847656 194.085938 175.921875 180.5625 185.730469 C 197.128906 162.726562 224.855469 146.828125 256.300781 146.828125 "
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      stroke: "none",
      fillRule: "nonzero",
      fill: "rgb(97.254902%,60.000002%,10.980392%)",
      fillOpacity: 1
    },
    d: "M 83.179688 81.871094 C 73.375 89.3125 63.566406 99.800781 55.792969 108.597656 C 99.070312 42.628906 173.121094 0 256.300781 0 C 340.15625 0 414.207031 43.304688 456.8125 108.597656 L 417.925781 132.617188 L 417.25 131.941406 C 337.789062 21.3125 188.675781 -1.351562 83.179688 81.871094 "
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudible);
export default __webpack_public_path__ + "static/media/audible.afd8ec9853c8aec64074d4f7ae926a2b.svg";
export { ForwardRef as ReactComponent };